import {configureStore} from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './rootSaga';
import exampleSlice from './example/exampleSlice';
import apiSlice from "./api/apiSlice";
import searchAndFilterSlice from "./searchAndFilter/searchAndFilterSlice";
import chatbotSlice from "./chatbot/chatbotSlice";
import threadsSlice from "./threads/threadsSlice";
import messagesSlice from "./messages/messagesSlice";
import filesSlice from "./files/filesSlice";
import catalogSlice from "./catalog/catalogSlice";
import lapSlice from "./lap/lapSlice";
import schemaSlice from "./schema/schemaSlice";
import authSlice from "./auth/authSlice";
import projectsSlice from "./projects/projectsSlice";
import projectDynamosSlice from "./projectDynamos/projectDynamosSlice";
import rddReducer from "./rdds/rddSlice";
import localTaskForceRolesReducer from "./localTaskForceRoles/localTaskForceRoleSlice";
import localCommunityTrainerRoleReducer from "./localCommunityTrainerRoles/localCommunityTrainerRoleSlice";
import domainReducer from "./domains/domainSlice";
import territorialChallengesReducer from "./territorialChallenges/territorialChallengesSlice";
import draftsReducer from "./drafts/draftsSlice";
import publishedSolutionsReducer from "./published/publishedSolutionsSlice";
import lapReducer from "./laps/lapSlice";
import solutionProposalsReducer from "./solutionProposals/solutionProposalsSlice";
import agentsReducer from "./agents/agentsSlice";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
    reducer: {
        example: exampleSlice,
        api: apiSlice,
        searchFilter: searchAndFilterSlice,
        chatbot: chatbotSlice,
        threads: threadsSlice,
        messages: messagesSlice,
        files: filesSlice,
        catalog: catalogSlice,
        lap: lapSlice,
        schema: schemaSlice,
        auth: authSlice,
        projects: projectsSlice,
        projectDynamos: projectDynamosSlice,
        rdds: rddReducer,
        localTaskForceRoles: localTaskForceRolesReducer,
        localCommunityTrainerRoles: localCommunityTrainerRoleReducer,
        domains: domainReducer,
        territorialChallenges: territorialChallengesReducer,
        drafts: draftsReducer,
        publishedSolutions: publishedSolutionsReducer,
        laps: lapReducer,
        solutionProposals: solutionProposalsReducer,
        agents: agentsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({thunk: false}).concat(sagaMiddleware),
});
sagaMiddleware.run(rootSaga);

export default store;
